export default "__VITE_ASSET__spBNA2N8__"